import { render, staticRenderFns } from "./grid-form.vue?vue&type=template&id=64340f3f&scoped=true&"
import script from "./grid-form.vue?vue&type=script&lang=js&"
export * from "./grid-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64340f3f",
  null
  
)

export default component.exports